<template>
    <div>
        <d-modal
                v-cloak
                name="mortgageInn"
                size="sms"
                :no-scroll="true"
                popup-title="Проверка организации"
            >
            <p class="p1" v-if="program === 'far-east'">Пожалуйста, укажите ИНН или наименование организации, в которой вы работаете, чтобы узнать соответствует ли вид деятельности организации требованиям программ </p>
            <p class="p1" v-else> Пожалуйста, укажите ИНН или наименование организации, в которой вы работаете, чтобы узнать возможность применения данной опции </p>
                <div class="inn-wrapper">
                    <div class="noUi noui_pb">
                        <div class="noUi__input noui__input_hide-border">
                            <vue-suggestion
                                id="inn"
                                class="noUi__text p1 inn-input"
                                v-model="inn"
                                label="ИНН"
                                method="party"
                                @select="suggestionOptions.onSelect($event)"
                            >
                            </vue-suggestion>
                        </div>
                    </div>
                </div>
                <div class="_dflex-block">
                    <a href="#" class="button button_light _mr-24-0" @click.prevent="$modal.hide('mortgageInn')">Назад</a>
                    <a href="#" class="button button_green _mt-0-16" @click.prevent="checkOkved">Проверить</a>
                </div>
                <div class="inn-success _mt-16" v-if="innChecker === 'success'">
                        <div class="inn-special-wrapper">
                            <div class="inn-special-icon__yes"></div>
                            <div class="inn-special-text" v-if="program === 'far-east'">Организация соответствует требованиям. Для проверки соответствия остальным условиям программы обратитесь к менеджеру банка</div>
                            <div class="inn-special-text" v-else>Организация соответствует требованиям</div>
                        </div>
                        <mortgage-send-with-lk additional-classes="button_green _mt-8" :lk-redirect="lkRedirect" v-if="program !== 'far-east'" />
                </div>
                <div class="inn-failure _mt-16" v-if="innChecker === 'failure'">
                        <div class="inn-special-wrapper">
                            <div class="inn-special-icon__no"></div>
                            <div class="inn-special-text" v-if="program === 'far-east'">Организация не соответствует требованиям. Для проверки соответствия остальным условиям программы обратитесь к менеджеру банка</div>
                            <div class="inn-special-text" v-else>Организация не соответствует требованиям</div>
                        </div>
                </div>
        </d-modal>
    </div>
</template>

<script>
export default {
    name: "mortgageOkvedChecker",
    props: {
        program: {
            type: String,
            default: "",
        },
        lkRedirect: {
            type: String,
            default: "",
        }
    },
    data() {
        return {
            inn: '',
            okved: '',
            innChecker: '',
            dfoOkveds: ['86', '86.1', '86.10', '86.2', '86.21', '86.22', '86.23', '86.9', '86.90', '86.90.1', '86.90.2', '86.90.4', '86.90.9', '87', '87.1', '87.10', '87.2', '87.20', '87.3', '87.30',
                        '87.9', '87.90', '85', '85.1', '85.11', '85.12', '85.13', '85.14', '85.2', '85.21', '85.22', '85.22.1', '85.22.2', '85.22.3', '85.23', '85.3', '85.4', '85.41',
                        '85.41.1', '85.41.2', '85.41.9', '85.41.91', '85.41.99', '85.42', '85.42.1', '85.42.2', '85.42.9', '86.22.9', '86.23', '86.90.3', '86.90.5', '86.22.1', '86.22.9',
                        '86.23', '86.90.3', '86.90.5'],
            medOkveds: ['86.1', '86.10', '86.2', '86.21', '86.22', '86.23', '86.9', '86.90', '86.90.1', '86.90.2', '86.90.4', '86.90.9'],
            okvedsAll: [], // Все окведы по организации
            suggestionOptions: {
                onSelect: (suggestion) => {
                    this.okved = suggestion.data?.okved;
                    this.inn = suggestion?.value;
                    if (suggestion.data?.okveds) {
                        if (suggestion.data?.okveds.length > 1) {
                            this.okvedsAll = suggestion.data.okveds;
                        }
                    }
                }
            },
        }
    },
    methods: {
        checkOkved() {
            if (this.$props.program === 'far-east') {
                this.innChecker = this.dfoOkveds.includes(this.okved) ? 'success' : 'failure';
            }
            else if (this.$props.program === 'mortgage-medical') {
                let okvedFirstChecker = this.medOkveds.filter(val => val === this.okved);
                let okvedSecondChecker = this.okvedsAll.filter(val => this.medOkveds.indexOf(val.code) !== -1);
                this.innChecker = okvedFirstChecker.length > 0 || okvedSecondChecker.length > 0 ? 'success' : 'failure';
            }
        }
    }
}
</script>
